import React, { useState } from "react";
import Style from "./Warning.module.css";

import { RiDeleteBin6Line } from "react-icons/ri";
import { useClearLogs } from "../../../hooks/useLogs";

const RemoveConfirmation = ({ onClose, onSucess, datas, errorData }) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const { ClearLogs } = useClearLogs();

  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      await ClearLogs(datas);
      onSucess();
      onClose();
    } catch (error) {
      errorData(error);
      onClose();
    } finally {
      setIsDeleting(false);
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <div className={Style.WarningdeleteConfirmation}>
      <div className={Style.WarningconfirmationCard}>
        <>
          <div className={Style.WarningiconContainer}>
            <RiDeleteBin6Line size={50} color="red" />
          </div>

          <h3>Delete the log</h3>
          <p className={Style.Warrningpara}>This action cannot be undone.</p>

          <div className={Style.WarningbuttonGroup}>
            <button
              className={Style.WarningcancelBtn}
              onClick={handleCancel}
              disabled={isDeleting}
            >
              Cancel
            </button>
            <button
              className={`${Style.WarningdeleteBtn} ${
                isDeleting ? Style.Warningdeleting : ""
              }`}
              onClick={handleDelete}
              disabled={isDeleting}
            >
              {isDeleting ? (
                <div className={Style.Warningspinner}></div>
              ) : (
                "Delete"
              )}
            </button>
          </div>
        </>
      </div>
    </div>
  );
};

export default RemoveConfirmation;
